import React, { ReactNode } from 'react';
import { RenderMark, RenderNode } from '@contentful/rich-text-react-renderer';
import {
  Block,
  BLOCKS,
  INLINES,
  Inline,
  MARKS
} from '@contentful/rich-text-types';

import { usePageDataContext } from '../../../../context/PageData';

import RichText from '../../../RichText';
import { EmbeddedInlineEntryNode } from '../../../RichText/Nodes';
import Link from '../../../Link';

export function PageFootnotes(data: any) {
  const {
    minAprAmount,
    maxAprAmount,
    effectiveDateConversion = {}
  } = usePageDataContext();

  const updatePageFootnotesApr = (pageFootnotes: ReactNode) => {
    if (pageFootnotes?.toString().includes('$[Min APR Range]')) {
      let replaceAprFootnotes = pageFootnotes
        ?.toString()
        .replace('$[Min APR Range]', String(minAprAmount));

      replaceAprFootnotes = replaceAprFootnotes?.replace(
        '$[Max APR Range]',
        String(maxAprAmount)
      );

      const effectiveDate = new Date(effectiveDateConversion);
      replaceAprFootnotes = replaceAprFootnotes?.replace(
        '$[Effective Date]',
        `${effectiveDate.toLocaleString('en-us', {
          month: 'long'
        })} ${effectiveDate.getDate()}, ${effectiveDate.getFullYear()}`
      );

      return replaceAprFootnotes;
    }
    return pageFootnotes;
  };

  const RICH_TEXT_OVERRIDE: RenderNode = {
    [BLOCKS.PARAGRAPH]: (_node: Block | Inline, children) => {
      return (
        <p className="typography-body-3 tablet:typography-body-2 whitespace-pre-wrap break-words font-normal text-on-screen-surface-dark [&:last-child]:mb-0 [&:not(:last-child)]:mb-6">
          {updatePageFootnotesApr(children)}
        </p>
      );
    },
    [INLINES.HYPERLINK]: (node, children) => (
      <Link
        href={node.data.uri}
        className="font-normal text-on-screen-surface-dark underline transition-colors duration-200 hover:text-[#00D9B4]"
      >
        {children}
      </Link>
    ),
    [INLINES.EMBEDDED_ENTRY]: (node, children) => (
      <EmbeddedInlineEntryNode
        node={node}
        colour="footerTextSecondary"
        fontWeight="400"
      >
        {children}
      </EmbeddedInlineEntryNode>
    ),
    [BLOCKS.UL_LIST]: (_node: Block | Inline, children) => (
      <ul className="list-none pl-7">{children}</ul>
    )
  };

  const RICH_TEXT_MARK_OVERRIDE: RenderMark = {
    [MARKS.CODE]: (children) => {
      const notesToId: any = {
        '*': 'single',
        '**': 'double',
        '†': 'obelus'
      };

      const note = notesToId[children as string] ?? children;

      return <span id={`gl-disclaimer-${note}`}>{children}</span>;
    }
  };

  return (
    <div
      id="page-footnotes"
      data-testid="page-footnotes"
      className="block-container"
    >
      <div className="column w-full !max-w-full flex-col">
        <RichText
          colour="footerTextSecondary"
          data={data}
          overrideOptions={RICH_TEXT_OVERRIDE}
          overrideMarkOptions={RICH_TEXT_MARK_OVERRIDE}
        />
      </div>
    </div>
  );
}
